export default "__VITE_ASSET__Zu73KH70__"